import { countries } from 'constants/countries'
import { OpSelect } from 'components/customAntd/DLS/OpSelect/OpSelect';

interface ICountrySelectProps {
  onSelect(shortCode: string): void;
  value?: string;
  disabled?: boolean;
}

export const CountrySelect = ({
  onSelect,
  value = 'US',
  disabled,
}: ICountrySelectProps) => {
  const options = countries.map((item) => {
    const optionLabel = `${item.name} +${item.phoneCode}`;
    const fixedProps = {
      key: optionLabel,
      value: item.short,
      label: (
        <>
          {item.emoji} +{item.phoneCode}
        </>
      ),
    };
    return (
      <OpSelect.Option {...fixedProps}>
        {item.emoji} {optionLabel}
      </OpSelect.Option>
    );
  });

  return (
    <OpSelect
      bordered={false}
      popupMatchSelectWidth={false}
      optionLabelProp="label"
      onSelect={onSelect}
      defaultValue="US"
      value={value}
      disabled={disabled}
    >
      {options}
    </OpSelect>
  );
};
